import { Component, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-nickname',
  shadow: false,
})
export class UgcReviewNickname {
  @Prop() customerProfileLink: string = '';
  @Prop() customerNickname: string = '';
  @Prop() fontType: FontType = FontType.large;
  render() {
    const fontType = this.fontType === FontType.large ? 'fs-16' : 'fs-14';
    return (
      <a
        href={`${state.domains.catalog || ''}/me/${this.customerProfileLink}`}
        class={`${fontType} color-blue-dark break-word bold hover-link-blue-dark`}
      >
        {this.customerNickname}
      </a>
    );
  }
}
